import ApiClient from './ApiClient';

export default class EventsApiClient extends ApiClient {
    
    list() {

        return super.post('Events', 'List', {});

    }
    
    query(server, category, name, startDate, endDate) {

        return super.post('Events', 'Query', {
              Server: server,
              Category: category,
              Name: name,
              StartDate: startDate,
              EndDate: endDate
        });

    }

}


// WEBPACK FOOTER //
// ./src/stores/EventsApiClient.js